import { Navigate } from "react-router-dom";
import { useUser } from "../context/UserContext";

const GuestRoute = ({ children }) => {
  const { user } = useUser();

  // 🔒 Si l'utilisateur est déjà connecté
  if (user && user.token) {
    return <Navigate to="/" replace />;
  }

  // ✅ Sinon, accès autorisé (login, register, reset…)
  return children;
};

export default GuestRoute;